<template>
  <div class="search-cont">
    <div class="zhezhao"></div>
    <div class="center">
      <div v-if="failure" class="reSub" @click="reSubmit">重新认证</div>
      <div class="close" @click="closePage">
        <img src="../../assets/img/close.png" alt />
      </div>
      <div class="success">
        <img src="../../assets/img/checking.png" alt />
      </div>
      <p>{{note}}</p>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      note: "",
      failure:false
    };
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    closePage() {
      this.$parent.$data.panelModal = false;
    },
    getStatus() {
      this.$http
        .get("/api/media/007--accountSetting", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          console.log(res, "获取认证状态");
          if (res.data.code == 0) {
            if (res.data.rows.length == 0) {
              this.sta == "";
            } else {
              this.sta = res.data.rows[0].status;
              if(this.sta == 1){
                this.note = '您已提交认证，请等待审核'
              }else if(this.sta == 3){
                this.note = '您已通过认证'
              }else{
                this.failure = true
                this.note = res.data.rows[0].remark;
              }
             
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    reSubmit(){
      document.documentElement.scrollTop = 0;
      this.$parent.$data.panelModal = true;
      this.$parent.$data.name = "authentic";
    }
  }
};
</script>
<style scoped>
.zhezhao {
  background: rgba(255, 255, 255, 1);
}
.search-cont .center {
  width: 800px;
  height: 300px;
  margin-left: -400px;
}
.search-cont .center .success {
  width: 100px;
  height: 82px;
  margin: 100px auto 25px;
}
.search-cont .center p {
  text-align: center;
}
.reSub {
  width: 80px;
  height: 38px;
  line-height:38px;
  float: left;
  border-radius: 4px;
  border:1px solid #eee;
  color:#999
}
.reSub:hover{
  color:#2E8043;
  border:1px solid #2E8043;
  cursor: pointer
}
</style>